import React from 'react';
import HeaderTopic from '../../partials/HeaderTopic';
import BasicButtons from '../../partials/BasicButtons';
import FooterMenu from '../../partials/FooterMenu';
import { getCitysCourts } from '../../api/getCitysCourts';
import { editMatch } from '../../api/editMatch';
import { deleteMatch } from '../../api/deleteMatch';
import * as func from '../../utils/funcs';
import { useHistory, useParams } from 'react-router-dom';

import styles from './MatchEdit.module.css';

function MatchEdit(props) {
  const { user, league, teams, rounds, matches, refreshStates } = props;
  const { leagueId, roundId, matchId } = useParams();
  const history = useHistory();

  const [courts, setCourts] = React.useState([]);

  const matchInfo = func.reFormatMatchData(
    matches.filter(match => match.id === parseInt(matchId, 10))[0]
  );

  const [group1, setGroup1] = React.useState(matchInfo.teams[0].id);
  const [group2, setGroup2] = React.useState(matchInfo.teams[1].id);
  const [court, setCourt] = React.useState('');
  const [time, setTime] = React.useState(matchInfo.start_time.slice(11, 16));

  const [textError, setTextError] = React.useState('');

  React.useEffect(() => {
    let mounted = true;

    getCitysCourts(league.city).then(data => {
      const tmpMatchInfo = func.reFormatMatchData(
        matches.filter(match => match.id === parseInt(matchId, 10))[0]
      );
      mounted && setCourts(data);
      mounted && setCourt(tmpMatchInfo.court);
    });

    return function cleanup() {
      mounted = false;
    };
  }, [league, matchId, matches]);

  // submit the data to the api and move to the round url
  const handleSubmit = async () => {
    if (group1 === '') {
      setTextError('לא בחרת קבוצה 1');
    } else if (group2 === '') {
      setTextError('לא בחרת קבוצה 2');
    } else if (group1 === group2) {
      setTextError('בחרת את אותה הקבוצה פעמיים');
    } else if (court === '') {
      setTextError('לא בחרת מגרש');
    } else if (time === '00:00:00.00') {
      setTextError('לא בחרת זמן למשחק');
    } else {
      setTextError('');
      const res = await editMatch(
        parseInt(leagueId, 10),
        parseInt(roundId, 10),
        parseInt(matchId, 10),
        group1,
        group2,
        func.makeDateFromTime(func.getRound(roundId, rounds).round_date, time),
        court
      );
      if (!res.error) {
        history.push(`/leagues/${leagueId}/rounds/${roundId}`);
      }
    }
  };

  const handleClickDelete = async () => {
    setTextError('מחיקת משחק...');
    const res = await deleteMatch(
      parseInt(leagueId, 10),
      parseInt(roundId, 10),
      parseInt(matchId, 10)
    );
    if (res.error) {
      setTextError('המשחק לא נמחק - נסה שוב');
    } else {
      history.push(`/leagues/${leagueId}/rounds/${roundId}`);
    }
  };

  return (
    <div className={styles.editMatch}>
      <HeaderTopic topic={'ליגת ' + league.name} />
      <BasicButtons user={user} refreshStates={refreshStates} />

      <FooterMenu setActive="vs" />

      <h2 className="sectionTitleSize">עריכת משחק</h2>
      <h4>
        מחזור {func.getRound(roundId, rounds).round_number} -{' '}
        {func.showDate(func.getRound(roundId, rounds).round_date)}
      </h4>

      <form>
        <select
          value={group1}
          onChange={e => {
            setGroup1(e.target.value);
          }}
        >
          <option value="" hidden>
            קבוצה
          </option>
          {teams.map(group => (
            <option key={group.id} value={group.id}>
              {group.name}
            </option>
          ))}
        </select>

        <select
          value={group2}
          onChange={e => {
            setGroup2(e.target.value);
          }}
        >
          <option value="" hidden>
            קבוצה
          </option>
          {teams.map(group => (
            <option key={group.id} value={group.id}>
              {group.name}
            </option>
          ))}
        </select>

        <select
          value={court}
          onChange={e => {
            setCourt(e.target.value);
          }}
        >
          <option value="" hidden>
            בחירת מגרש
          </option>
          {courts &&
            courts.map(court1 => (
              <option value={court1.id} key={court1.id}>
                {court1.name}
              </option>
            ))}
        </select>

        <input
          type="time"
          value={time}
          onChange={e => {
            setTime(e.target.value);
          }}
        />

        <span className={styles.errorMsg}>{textError}</span>

        <button type="button" className="btnLarge" onClick={handleSubmit}>
          עריכת משחק
        </button>

        <button type="button" className="btnMedium" onClick={handleClickDelete}>
          מחיקת משחק
        </button>
      </form>
    </div>
  );
}

export default MatchEdit;
